import {
  TrackingBrandInteraction,
  TrackingContentInteraction,
  TrackingOutfitInteraction,
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
  TrackingStoryInteraction,
} from '../../../types'
import { DataLayerEvent } from '../helpers/datalayer'
import { stringifyEventData } from '../helpers/stringifyEventData'

interface ContentViewInteractionGA4 {
  event: 'interaction'
  page_type: TrackingPageTypeWithId | TrackingPageTypeWithoutId | null
  name:
    | TrackingStoryInteraction['type']
    | TrackingOutfitInteraction['type']
    | TrackingBrandInteraction['type']
  action: 'like' | 'dislike' | 'read'
  label: string
  title: string
  destination_url: string
}

export interface ContentViewInteractionEvent {
  GA3: DataLayerEvent
  GA4: ContentViewInteractionGA4
}

export const trackContentInteraction =
  ({ interaction }: { interaction: TrackingContentInteraction }) =>
  (): ContentViewInteractionEvent => ({
    GA3: {
      event: interaction.type + 'Interaction',
      action: stringifyEventData([
        interaction.label,
        interaction.type === 'brand' ? interaction.name : interaction.headline,
        interaction.url,
      ]),
      label: interaction.action,
      value: null,
    },
    GA4: {
      event: 'interaction',
      page_type: interaction.pageType || null,
      name: interaction.type,
      action: interaction.action,
      label: interaction.label,
      title:
        interaction.type === 'brand' ? interaction.name : interaction.headline,
      destination_url: interaction.url,
    },
  })
